import { useEffect } from "react";
import { BOOptionModel } from "../../../data-model/boOptionModel";
import { AllCommentsProps } from "../../../data-model/busniessOfficeNote";
import { computeGlobalBoValue } from "../../../utils/busniessOfficeNotesHelper";

/**
 * Custom hook that calculates and updates the global BO value based on final comments.
 * The global BO value is determined by:
 * - If there's exactly one final comment with one comment entry, use that comment's boStatus
 * - If there's exactly one final comment with multiple comment entries, use the lowest priority option
 * - Otherwise, the global BO value remains empty
 */
export const useGlobalBoValue = (
  allCommentsForUI: AllCommentsProps[],
  boOptions: BOOptionModel[] | undefined,
  orderId: string | undefined,
  setGlobalBoValue: (value: string) => void,
  setGlobalBoValueInContext: (orderId: string, value: string) => void,
) => {
  useEffect(() => {
    const newGlobalBoValue = computeGlobalBoValue(
      allCommentsForUI,
      boOptions ?? [],
    );
    setGlobalBoValue(newGlobalBoValue);
    if (orderId) {
      setGlobalBoValueInContext(orderId, newGlobalBoValue);
    }
  }, [
    allCommentsForUI,
    boOptions,
    orderId,
    setGlobalBoValue,
    setGlobalBoValueInContext,
  ]);
};
